// extracted by mini-css-extract-plugin
export default {"logo":"logo_LAP2WHe","image":"image_VM3JNur"};